import { render, staticRenderFns } from "./BulkSelectPanel.vue?vue&type=template&id=c88b2c70&"
import script from "./BulkSelectPanel.vue?vue&type=script&lang=js&"
export * from "./BulkSelectPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c88b2c70')) {
      api.createRecord('c88b2c70', component.options)
    } else {
      api.reload('c88b2c70', component.options)
    }
    module.hot.accept("./BulkSelectPanel.vue?vue&type=template&id=c88b2c70&", function () {
      api.rerender('c88b2c70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/organization/staffCalendar/BulkSelectPanel.vue"
export default component.exports